import { render, staticRenderFns } from "./MessageButtonsBar.vue?vue&type=template&id=79119dd4&scoped=true"
import script from "./MessageButtonsBar.vue?vue&type=script&lang=js"
export * from "./MessageButtonsBar.vue?vue&type=script&lang=js"
import style0 from "./MessageButtonsBar.vue?vue&type=style&index=0&id=79119dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79119dd4",
  null
  
)

export default component.exports